import { useContext } from "react";
import { useTranslation } from "react-i18next";
import ReportCard from "components/ReportCard";
import { DefaultTranslationFieldsInTable, SummaryOption } from "constants/constants";
import { CorporateDashboardContext } from "contexts/CorporateDashboardContext/CorporateDashboardContext";
import { IMillReportCardProps } from "pages/Corporate/Locations/MillDashboards/MillDashboardInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";
import DowntimeSecondaryFailureCodeByMill from "../DowntimeSecondaryFailureCodeByMill/DowntimeSecondaryFailureCodeByMill.view";
import MachineCentersPopover from "./MachineCentersPopover";
import { useStyles } from "./DowntimeSecondaryFailureCodeByMillReportCard.styles";

const DowntimeSecondaryFailureCodeByMillReportCard = ({ countryCode }: IMillReportCardProps) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const {
        selectedFailureType,
        selectedFailureCode,
        selectedSecondaryFailureCode,
        selectedMillPopoverData,
    } = useContext(CorporateDashboardContext);

    const defaultSecondaryFailureCodeTranslatedName = translateDefaultEntity(
        i18n.language,
        selectedSecondaryFailureCode,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_CODE,
    );

    const popoverOpen =
        selectedMillPopoverData !== null &&
        selectedMillPopoverData.summaryOption === SummaryOption.BY_SECONDARY_CODE;

    return (
        <ReportCard
            className={classes.mainWrapper}
            showNoData={!selectedFailureType || !selectedFailureCode || !selectedSecondaryFailureCode}
            noDataTitle={t("corporate_dashboard.downtime_by_secondary_failure_codes_by_mill.no_data")}
            title={
                selectedSecondaryFailureCode
                    ? t("corporate_dashboard.downtime_by_secondary_failure_codes_by_mill.title", {
                          secondaryFailureCode: defaultSecondaryFailureCodeTranslatedName,
                      })
                    : t("corporate_dashboard.downtime_by_secondary_failure_codes_by_mill.title_no_selected")
            }
        >
            <>
                <DowntimeSecondaryFailureCodeByMill countryCode={countryCode} />
                {popoverOpen && <MachineCentersPopover countryCode={countryCode} />}
            </>
        </ReportCard>
    );
};

export default DowntimeSecondaryFailureCodeByMillReportCard;
